import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import SyonetConnectionsAPI from '../../api/syonetConnections';
import { throwErrorMessage } from '../utils/api';

export const state = {
    records: [],
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
        isTestingConnection: false,
    },
};

export const getters = {
    getSyonetConnections($state) {
        return $state.records;
    },
    getUIFlags($state) {
        return $state.uiFlags;
    },
};

export const actions = {
    async get({ commit }) {
        commit(types.SET_SYONET_CONNECTIONS_UI_FLAG, { isFetching: true });
        try {
            const response = await SyonetConnectionsAPI.get();
            commit(
                types.SET_SYONET_CONNECTIONS,
                response.data.payload?.syonet_connections || []
            );
        } catch (error) {
            throwErrorMessage(error);
        } finally {
            commit(types.SET_SYONET_CONNECTIONS_UI_FLAG, { isFetching: false });
        }
    },
    async create({ commit }, { syonet_connection: syonetConnection }) {
        commit(types.SET_SYONET_CONNECTIONS_UI_FLAG, { isCreating: true });
        try {
            const response = await SyonetConnectionsAPI.create({
                syonet_connection: syonetConnection,
            });
            commit(
                types.ADD_SYONET_CONNECTION,
                response.data.payload?.syonet_connection || null
            );
            commit('integrations/SET_INTEGRATION_ENABLED', { appId: 'syonet', enabled: true }, { root: true });
        } catch (error) {
            throwErrorMessage(error);
        } finally {
            commit(types.SET_SYONET_CONNECTIONS_UI_FLAG, { isCreating: false });
        }
    },
    async update({ commit }, { id, syonet_connection: syonetConnection }) {
        commit(types.SET_SYONET_CONNECTIONS_UI_FLAG, { isUpdating: true });
        try {
            const response = await SyonetConnectionsAPI.update(id, {
                syonet_connection: syonetConnection,
            });
            commit(
                types.EDIT_SYONET_CONNECTION,
                response.data.payload?.syonet_connection || null
            );
        } catch (error) {
            throwErrorMessage(error);
        } finally {
            commit(types.SET_SYONET_CONNECTIONS_UI_FLAG, { isUpdating: false });
        }
    },
    async delete({ commit, getters }, id) {
        commit(types.SET_SYONET_CONNECTIONS_UI_FLAG, { isDeleting: true });
        try {
            await SyonetConnectionsAPI.delete(id);
            commit(types.DELETE_SYONET_CONNECTION, id);
            const remaining = getters.getSyonetConnections.filter(r => r.id !== id);
            commit('integrations/SET_INTEGRATION_ENABLED', { appId: 'syonet', enabled: remaining.length > 0 }, { root: true });
        } catch (error) {
            throwErrorMessage(error);
        } finally {
            commit(types.SET_SYONET_CONNECTIONS_UI_FLAG, { isDeleting: false });
        }
    },
    async testConnection({ commit }, { syonet_connection: syonetConnection }) {
        commit(types.SET_SYONET_CONNECTIONS_UI_FLAG, { isTestingConnection: true });
        try {
            const response = await SyonetConnectionsAPI.testConnection(syonetConnection);
            return response.data;
        } catch (error) {
            throwErrorMessage(error);
            return null;
        } finally {
            commit(types.SET_SYONET_CONNECTIONS_UI_FLAG, { isTestingConnection: false });
        }
    },
};

export const mutations = {
    [types.SET_SYONET_CONNECTIONS_UI_FLAG]($state, data) {
        $state.uiFlags = {
            ...$state.uiFlags,
            ...data,
        };
    },
    [types.SET_SYONET_CONNECTIONS]: MutationHelpers.set,
    [types.ADD_SYONET_CONNECTION]: MutationHelpers.setSingleRecord,
    [types.EDIT_SYONET_CONNECTION]: MutationHelpers.update,
    [types.DELETE_SYONET_CONNECTION]: MutationHelpers.destroy,
};

export default {
    namespaced: true,
    actions,
    state,
    getters,
    mutations,
};
